export default __webpack_public_path__ + "static/media/GiveawayBackground.ecc887d9.jpg";